import styled from 'styled-components';

export const InfoFlex = styled.div`
  display: flex;
  gap: 1.5rem;

  > p {
    &:nth-child(2) {
      font-weight: 900;
    }
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  width: 100%;
`;

export const GaugeContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: .75rem;
  gap: 1rem;
`;

export const Title = styled.p`
  font-size: 1.5rem;
`;

export const ResponseBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-top: 1rem;
`;

export const AnswersWrapper = styled.div`
  margin-top: 1rem;

  > .title {
    text-align: center;
    font-size: 1.25rem;
    margin-bottom: 1.5rem;
  }
`;

export const AnswersGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const AnswerContainer = styled.div`
  border: 1px solid #cbd5e0;
  padding: 1rem;
  border-radius: .25rem;

  label {
    font-weight: 700;
  }

  > p {
    display: flex;
    align-items: center;
    gap: .2rem;
    font-weight: 700;
  }

  > .red {
    color: #f56565;
  }
`;

export const IndentedAnswer = styled.div`
  margin-top: .5rem;
  border-left: 2px solid #ecf0f1;
  padding-left: 1rem;
  margin-left: 1rem;
`;

export const TableStyle = styled.table`
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  > thead tr {
    > th {
      color: #718096;
      padding-bottom: .5rem;
      border-bottom: 1px solid #e2e8f0;
        &:nth-child(1) {
          width: 34%;
        }
     }
  }

  > tbody tr {
    > td {
      padding: 0.5rem;
      border: 1px solid #e2e8f0;

      > span {
        display: flex;
        justify-content: space-between;

        > span {
          &:nth-child(1) {
            color: black;
            font-weight: 700;
          }

          &:nth-child(2) {

            font-style: italic;
            font-size: .75rem;
            color: #a0aec0;
          }
        }
      }

      &.very-low {
        background-color: #e6fffa;
        &.selected {
          background-color: #c6f6d5;
        }
      }
      &.medium {
        background-color: ivory;
        &.selected {
          background-color: #fefcbf;
        }
      }
      &.high {
        background-color: #fffaf0;
        &.selected {
          background-color: #feebc8;
        }
      }
      &.very-high {
        background-color: #fff5f5;
        &.selected {
          background-color: #fed7d7;
        }
      }
      &.danger {
        background-color: #ebf8ff;
        &.selected {
          background-color: #bee3f8;
        }
      }
    }
  }
`;

export const TableStyle2 = styled.table`
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  margin-top: 1.5rem;

  > thead tr {
    > th {
      color: #718096;
      padding-bottom: .5rem;
      border-bottom: 1px solid #e2e8f0;

      &:nth-child(1) {
        text-align: left;
      }
    }
  }

  > tbody tr {
    > td {
      text-align: center;
      padding: .75rem 0;
      border-bottom: 1px solid #e2e8f0;

      &:nth-child(1) {
        text-align: left;
      }
    }
  }

`;